export enum QuizType {
  GradedQuiz = 'graded_quiz',
  UngradedSurvey = 'ungraded_survey',
  GradedSurvey = 'graded_survey',
}

export const isSurvey = (quizType: QuizType): boolean => {
  return quizType === QuizType.UngradedSurvey || quizType === QuizType.GradedSurvey
}

export const isGraded = (quizType: QuizType): boolean => {
  return quizType === QuizType.GradedQuiz || quizType === QuizType.GradedSurvey
}
